module.exports = __webpack_public_path__ + "static/media/layer.eb0344e1.svg";